module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_8_B_1.b9eb125d.mp3";